// 拜访记录
import {dynamicPropsFn} from './util.js'
const VisitRecordList = resolve => require(['@/views/VisitRecord/List'], resolve)
const VisitRecordDetail = resolve => require(['@/views/VisitRecord/Detail'], resolve)
const VisitRecordNew = resolve => require(['@/views/VisitRecord/New'], resolve)
const VisitRecordEdit = resolve => require(['@/views/VisitRecord/Edit'], resolve)

const ProjectVisitRecordDetail = resolve => require(['@/views/VisitRecord/ProjectVisitRecord/Detail'], resolve)
const ProjectVisitRecordNew = resolve => require(['@/views/VisitRecord/ProjectVisitRecord/New'], resolve)
const ProjectVisitRecordEdit = resolve => require(['@/views/VisitRecord/ProjectVisitRecord/Edit'], resolve)

const EvaluateRecordDetail = resolve => require(['@/views/VisitRecord/EvaluateRecord/Detail'], resolve)
export default [
  {
    name: 'VisitRecord_List',
    path: '/VisitRecord/list',
    component: VisitRecordList,
    meta: {
      keepAlive: false,
      title: '拜访记录列表',
    },
  },
  {
    name: 'VisitRecord_detail',
    path: '/VisitRecord/detail',
    component: VisitRecordDetail,
    meta: {
      keepAlive: false,
      title: '拜访记录详情',
    },
  },
  {
    name: 'VisitRecord_new',
    path: '/VisitRecord/new',
    component: VisitRecordNew,
    meta: {
      keepAlive: false,
      title: '新建拜访记录',
    },
  },
  {
    name: 'VisitRecord_edit',
    path: '/VisitRecord/edit',
    component: VisitRecordEdit,
    props: dynamicPropsFn,
    meta: {
      keepAlive: false,
      title: '编辑拜访记录',
    },
  },
  {
    name: 'ProjectVisitRecord_detail',
    path: '/VisitRecord/ProjectVisitRecord/detail',
    component: ProjectVisitRecordDetail,
    meta: {
      keepAlive: false,
      title: '项目拜访记录详情',
    },
  },
  {
    name: 'ProjectVisitRecord_new',
    path: '/VisitRecord/ProjectVisitRecord/new',
    component: ProjectVisitRecordNew,
    meta: {
      keepAlive: false,
      title: '新建项目拜访记录',
    },
  },
  {
    name: 'ProjectVisitRecord_edit',
    path: '/VisitRecord/ProjectVisitRecord/edit',
    component: ProjectVisitRecordEdit,
    props: dynamicPropsFn,
    meta: {
      keepAlive: false,
      title: '编辑项目拜访记录',
    },
  },
  {
    name: 'EvaluateRecord_detail',
    path: '/VisitRecord/EvaluateRecord/detail',
    component: EvaluateRecordDetail,
    meta: {
      keepAlive: false,
      title: '内部评价信息详情',
    },
  },
]



// WEBPACK FOOTER //
// ./src/router/visitRecord.js